import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  list: [],
  // 选中的出行人列表
  selectedTravelerList: []
};

/**
 * 更新选中的出行人列表
 * @param {Array} prevList 更新前的选中的出行人列表
 * @param {Array} updateList 需要更新的出行人列表
 * @param {Boolean} isChoose 是否是直接选择 (如果更新前的选中的出行人列表中没有当前需要更新的出行人 是否需要追加)
 */
function updateSelectedList(prevList, updateList, isChoose) {
  const addList = [...updateList];
  const newList = prevList.map((item) => {
    let newItem = item;
    const findIndex = addList.findIndex((updateItem) => {
      return updateItem.id === item.id;
    });
    if (findIndex > -1) {
      const findList = addList.splice(findIndex, 1);
      const findItem = findList[0];
      console.log('寻找到的出行人信息', item, findItem, findItem.travelerDocumentList)
      // 防止从更新接口进入的 出行人证件中没有身份证情况
      if (!isChoose && !findItem.travelerDocumentList.some(({ id }) => { return id === null })) {
        findItem.travelerDocumentList.splice(0, 0, {
          id: null,
          documentType: 1,
          documentTypeName: "身份证",
          documentNum: findItem.idCard,
          expireDate: findItem.validDate || null,
        })
      }
      // 防止选中的证件信息发生变化
      if (!isChoose && item.certificateInfo) {
        // 查询该用户最新的证件信息
        const newCertificate = findItem.travelerDocumentList.find(({ id }) => { return item.certificateInfo.documentId === id; });
        if (newCertificate) {
          console.log('newCertificate', newCertificate);
          const { id: documentId, ...rest } = newCertificate;
          findItem.certificateInfo = { documentId, ...rest };
        }
      }
      newItem = { ...item, ...findItem };
    }
    return newItem;
  });
  // 如果是直接选择 则如果更新前的选中的出行人列表中没有当前需要更新的出行人 需要追加
  const retList = isChoose ? (addList && addList.length>0 ? updateList.length>addList.length ? updateList : addList : newList) : newList;
  return retList;
}

export default function travelerList(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 获取出行人列表
    case ACTION_TYPES.GET_TRAVELER_LIST:
      result.list = payload;
      break;
    // 清除选中的出行人列表信息
    case ACTION_TYPES.CLEAR_ORDER_CONFIRM_INFO:
    case ACTION_TYPES.CLEAR_SELECTED_TRAVELER_LIST:
      result.selectedTravelerList = INIT_STATE.selectedTravelerList;
      break;
    // 更新出行人信息
    case ACTION_TYPES.UPDATE_TRAVELER:
      result.selectedTravelerList = updateSelectedList(result.selectedTravelerList, [payload], false);
      break;
    // 删除出行人信息
    case ACTION_TYPES.DELETE_TRAVELER:
      result.selectedTravelerList = result.selectedTravelerList.filter((item) => { return item.id !== payload });
      break;

    // 更新选中的出行人信息
    case ACTION_TYPES.UPDATE_SELECTED_TRAVELER:
      result.selectedTravelerList = updateSelectedList(result.selectedTravelerList, payload, true);
      break;
    // 删除选中的出行人信息
    case ACTION_TYPES.DELETE_SELECTED_TRAVELER:
      result.selectedTravelerList = result.selectedTravelerList.filter((item) => { return !payload.includes(item.id) });
      break;
    default:
      result = state;
  }
  return result;
}
